export function getSum(arr: number[]): number {
  return arr.reduce((accum, item) => accum + item, 0);
}
